/* tslint:disable */
/* eslint-disable */
/**
 * medications
 * medications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicationStockSignOffSignedBy
 */
export interface MedicationStockSignOffSignedBy {
    /**
     * 
     * @type {string}
     * @memberof MedicationStockSignOffSignedBy
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationStockSignOffSignedBy
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationStockSignOffSignedBy
     */
    last_name?: string;
}

/**
 * Check if a given object implements the MedicationStockSignOffSignedBy interface.
 */
export function instanceOfMedicationStockSignOffSignedBy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MedicationStockSignOffSignedByFromJSON(json: any): MedicationStockSignOffSignedBy {
    return MedicationStockSignOffSignedByFromJSONTyped(json, false);
}

export function MedicationStockSignOffSignedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationStockSignOffSignedBy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function MedicationStockSignOffSignedByToJSON(value?: MedicationStockSignOffSignedBy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

